import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "../../../shared/common.service";
import { SharedDataService } from "../../../shared/shared-data.service";
import { environment } from "../../../../environments/environment";
import { NavigationEnd, Router } from "@angular/router";
import Swal from "sweetalert2";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class AppHeaderComponent implements OnInit {
  @Input() title: string; // This will receive "Dashboard"
  currentUrl: any;
  operatorCode: any;
  isShow: boolean = false;
  showRefresh: boolean = false;
  constructor(
    private commonService: CommonService,
    private router: Router,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log("Route changed to:", event.urlAfterRedirects);
        this.currentUrl = event.urlAfterRedirects;
        console.log(this.currentUrl, "current usrl");
        if (
          this.currentUrl == "/main/users/list" ||
          this.currentUrl == "/main/manager/list"
        ) {
          this.showRefresh = true;
        }
        // debugger;
        const cleanUrl = this.currentUrl.split("?")[0];

        if (cleanUrl == "/main/users/usercards") {
          this.isShow = true;
        } else {
          this.isShow = false;
          // this.showRefresh = true;
        }
        // You can add logic here like:
        // this.trackPageView(event.urlAfterRedirects);
      });
    console.log(this.currentUrl, "current usrl");
    if (
      this.currentUrl == "/main/users/list" ||
      this.currentUrl == "/main/manager/list"
    ) {
      this.showRefresh = true;
    } else {
      this.showRefresh = false;
    }

    // debugger;
    const cleanUrl = this.currentUrl.split("?")[0];

    if (cleanUrl == "/main/users/usercards") {
      this.isShow = true;
    } else {
      this.isShow = false;
      // this.showRefresh = true;
    }
  }
  // openwebView(value) {
  //    window.open(url, "_blank");
  //  }
  logoutUser() {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        this.commonService.logOut();
        Swal.fire(
          "Logged out!",
          "You have been successfully logged out.",
          "success"
        );
      }
    });
  }

  navigateAPI() {
    this.router.navigate(["main/apikey/"]);
  }
  sendData() {
    this.sharedDataService.sendData("hello");
  }
  back() {
    this.router.navigate(["main/users/list"]);
  }
}
